import { User } from "~/entities/user/types";

export function isUserTypesafe(user: unknown): User | null {
  try {
    if (!user || typeof user !== "object") {
      throw new Error("User must be a non-null object");
    }

    const u = user as Record<string, unknown>;

    // Check required primitive properties
    if (
      typeof u.id !== "string" ||
      typeof u.email !== "string" ||
      typeof u.group !== "string" ||
      typeof u.signupGroup !== "string" ||
      typeof u.customerType !== "string" ||
      typeof u.doNotSellMyInformation !== "boolean"
    ) {
      throw new Error(
        "User must have valid id, email, group, signupGroup, customerType strings and doNotSellMyInformation boolean",
      );
    }

    // Check fullName which can be string or null
    if (u.fullName !== null && typeof u.fullName !== "string") {
      throw new Error("User fullName must be either a string or null");
    }

    // Check cart which can be Cart or null
    if (u.cart !== null && typeof u.cart !== "object") {
      throw new Error("User cart must be either a Cart object or null");
    }

    // If all checks pass, return the user
    return user as User;
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message);
    } else {
      console.error("An unknown error occurred");
    }

    return null;
  }
}
